mmf_modules.define('plugins/mmf_polyfill',[
    'jquery',
    'plugins/placeholder'
], function (
    $,
    placeholder_is_on_jquery_object
) {
    var Polyfill = {};

    // Array.indexOf Polyfill
    [].indexOf||(Array.prototype.indexOf=function(a,b,c){for(c=this.length,b=(c+~~b)%c;b<c&&(!(b in this)||this[b]!==a);b++);return b^c?b:-1;});

    // Avoid `console` errors in browsers that lack a console.
    // pulled from https://github.com/h5bp/html5-boilerplate/blob/master/js/plugins.js
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }

    /*
    * Polyfill for javascript .trim method
     */
    if (!String.prototype.trim) {
        String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/g, '');
        };
    }

    Polyfill.Placeholder = function () {
        $('input[placeholder], textarea[placeholder]').placeholder();
    };

    return Polyfill;
});
